export let CONST = {
    terc: '221201',
    woj: 'pomorskie',
    pow: 'powiat słupski',
    gmi: 'gmina miejska Ustka',
    simc: '0977427',
    city: 'Ustka',
    postalCode: '76-270',
    cardNameGen: 'Usteckiej Karty Mieszkańca',
    cardStyles: [] as string[]




};

if (process.env.VUE_APP_MODULE_CONST === 'slupsk' || (process.env.VUE_APP_API_URL && process.env.VUE_APP_API_URL.indexOf('slupskakarta') > -1)) {
    CONST = {
        terc: '2263011',
        woj: 'pomorskie',
        pow: 'powiat Słupsk',
        gmi: 'gmina miejska Słupsk',
        simc: '0977278',
        city: 'Słupsk',
        postalCode: '76-200',
        cardNameGen: 'Słupskiej Karty Mieszkańca',
        cardStyles: ['LOGO', 'RATUSZ']


    };

}



export default CONST;


